<!-- https://www.flaticon.com/packs/countrys-flags/ - flags pack -->
<!-- doesn't work in local environment ! -->
<img [src]="country" [matMenuTriggerFor]="countrySelect" alt="country flag"
    [ngClass]="{'general_header': general_header}">
<mat-menu #countrySelect="matMenu" class="countries-list">
    <div mat-menu-item *ngFor="let locale of locales | keyvalue" (click)="changeLanguage(locale.key)">
        <!-- <img [src]="'./assets/img/flags/' + locale.key + '.png'" alt="country flag"> -->
        {{ locale.value }}
    </div>
</mat-menu>